(function () {
  'use strict';

  function buildToggledUrl(param, value) {
    var url = new URL(window.location.href);
    var params = url.searchParams;
    params.delete('page');

    var current = params.getAll(param);
    var alreadySet = current.indexOf(value) !== -1;

    params.delete(param);
    current.forEach(function (v) {
      if (v !== value) params.append(param, v);
    });
    if (!alreadySet) params.append(param, value);

    return url;
  }

  function mainCollectionSectionId() {
    var results = document.querySelector('.collection__results');
    var section = results && results.closest('.shopify-section');
    return section ? section.id.replace('shopify-section-', '') : null;
  }

  function handleTileClick(e) {
    var tile = e.currentTarget;
    if (tile.disabled) return;

    var toggledUrl = buildToggledUrl(tile.dataset.filterParam, tile.dataset.filterValue);
    var collectionSectionId = mainCollectionSectionId();

    if (!collectionSectionId) {
      window.location.href = toggledUrl.toString();
      return;
    }

    // Hooks directly into the theme's native facet update pipeline (theme.js
    // FacetForm / the global "facet:update" listener) -- the exact same event
    // the sidebar checkboxes, sort-by, and "Clear filters" link use. This gets
    // us loading state, scroll-into-view, and history handling for free, and
    // guarantees this bar behaves identically to the sidebar filter it targets.
    toggledUrl.searchParams.set('section_id', collectionSectionId);
    document.dispatchEvent(new CustomEvent('facet:update', { bubbles: true, detail: { url: toggledUrl } }));
  }

  function bindTiles(scope) {
    scope.querySelectorAll('.visual-filter-item[data-filter-param]').forEach(function (tile) {
      tile.addEventListener('click', handleTileClick);
    });
  }

  function initBar(bar) {
    if (bar.dataset.vfbInit) return;
    bar.dataset.vfbInit = '1';

    bindTiles(bar);

    var ownSectionId = bar.dataset.sectionId;
    if (!ownSectionId) return;

    // The native facet:update listener in theme.js only replaces the
    // main-collection section -- it has no idea this sibling section exists.
    // Re-fetch just this section on every facet:update (regardless of what
    // triggered it -- a sidebar checkbox, a size pill, this bar itself) so its
    // active/disabled states and counts never go stale relative to whatever
    // filter combination is now applied.
    document.addEventListener('facet:update', function (event) {
      var url = new URL(event.detail.url);
      url.searchParams.set('section_id', ownSectionId);

      fetch(url.toString())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString('<div id="vfb-temp">' + html + '</div>', 'text/html');
          var freshBar = doc.querySelector('.visual-filter-bar');
          if (freshBar) {
            bar.innerHTML = freshBar.innerHTML;
            bindTiles(bar);
          }
        })
        .catch(function () {});
    });
  }

  function scan() {
    document.querySelectorAll('.visual-filter-bar[data-section-id]').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
